<div class="desktop-container">
    <div>
        <span class="intro">
            @if (promotion ; as promotion) {
                <div>
                    <h3 class="p-0 m-0">{{ promotion.title }}</h3>
                    <p>{{ promotion.creator.abbreviatedName }} sent you a safety promotion on {{dateUtils.formatDateWithConditionalYear(promotion.sentDate) }}</p>
                </div>
                    
            }
        </span>
 
    </div>
    <div class="form-type type-promotion">
        PROMOTION
    </div>
    <app-flight-card-cta class="w-full" [flight]="promotion" [type]="'promotion'" [isEditable]="showEdit" [canBeArchived]="true"></app-flight-card-cta>
</div>

<div class="mobile-container" (click)="$event.stopPropagation()">
  <app-combined-task-card-mobile
    [data]="promotion"
    [type]="'promotion'"
    [showEdit]="showEdit"
  ></app-combined-task-card-mobile>
</div>